export const apiINT = '/api/internal';
export const apiEXT = '/api/external';
export const apiORD = '/api';
